/**
 * Tipos de documento de un solicitante (usuario externo), tal como los maneja
 * el core en `ApplicantDocumentTypeEnum`.
 */
export type ApplicantDocumentType =
  "DUI" | "PASSPORT" | "CARNE_INSTITUCIONAL" | "NIT" | "OTHER";

export const DOCUMENT_TYPE_LABELS: Record<ApplicantDocumentType, string> = {
  DUI: "DUI",
  PASSPORT: "Pasaporte",
  CARNE_INSTITUCIONAL: "Carné de residente",
  NIT: "NIT",
  OTHER: "Otro documento",
};

/** Etiqueta del tipo de documento; un valor desconocido se muestra tal cual. */
export const getDocumentTypeLabel = (documentType?: string | null): string => {
  if (!documentType) return "";

  return (
    DOCUMENT_TYPE_LABELS[documentType.toUpperCase() as ApplicantDocumentType] ??
    documentType
  );
};

/**
 * Una persona jurídica se identifica con NIT o, si es extranjera y no tiene
 * NIT, con "Otro documento" (OTHER).
 */
export const isLegalPersonDocument = (documentType?: string | null): boolean =>
  ["NIT", "OTHER"].includes(documentType?.toUpperCase() ?? "");

/**
 * Opciones del selector de tipo de documento. "Otro documento" depende del
 * feature flag `other-document-type`, pero siempre se incluye si el registro
 * ya lo tiene para no dejar el selector vacío.
 */
export const getDocumentTypeOptions = ({
  includeOther,
  currentType,
}: {
  includeOther: boolean;
  currentType?: string | null;
}) =>
  (Object.keys(DOCUMENT_TYPE_LABELS) as ApplicantDocumentType[])
    .filter(
      (value) => value !== "OTHER" || includeOther || currentType === "OTHER",
    )
    .map((value) => ({ value, label: DOCUMENT_TYPE_LABELS[value] }));
